import { render } from "./formgroupupload.vue?vue&type=template&id=6a411904"
import script from "./formgroupupload.vue?vue&type=script&lang=js"
export * from "./formgroupupload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__